import React from "react";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {BlockContainer} from "BaseComponents/Wrappers";
import {useGlobal} from "reactn";
import {H2} from "BaseComponents/Text";
import styled from "styled-components";
import {BlockLink} from "BaseComponents/Link";
import {Video, VideoContainer} from "Components/Video";

export const VideoListBlock = ({Heading, HeadingUrl, VideoHits, LinkText, LinkUrl}) => {
    const [theme] = useGlobal("theme");
    return (
        VideoHits.length > 0 && (
            <BlockContainer>
                <VideoBlockContainer>
                    <Header
                        inline
                        margin="0 0 25px 0rem"
                        marginsmall="0 0 1rem 0"
                        color={theme.colors.primary}
                    >
                        {Heading}
                    </Header>
                    <VideoBlockWrapper>
                        {VideoHits.map((video, i) => {
                            return (
                                <VideoWrapper key={i}>
                                    <Video
                                        isBlock
                                        Heading={video.Heading}
                                        {...video.VideoHit}
                                        key={i}
                                        videoHeight={"100%"}
                                    />
                                </VideoWrapper>
                            );
                        })}
                    </VideoBlockWrapper>
                    <BlockLink href={LinkUrl} text={LinkText}/>
                </VideoBlockContainer>
            </BlockContainer>
        )
    );
};
export const Header = styled(H2)`
    & {
        font-size: 26px;
    }
`;
export const VideoWrapper = styled(VideoContainer)`
    ${media.greaterThan(breakpoints.mobile)`
	max-width: calc(50% - 30px);
	margin: 20px 0 0 20px;
	
	width: 100%;
	height: 200px;
`}
    margin: 10px 0;
`;
export const VideoBlockContainer = styled.div`
    ${media.lessThan(breakpoints.mobile)`
  padding: 0;

  `}
`;
export const ArticleBlockOuterWrapper = styled.div`
    max-width: ${({theme}) => theme.grid.outer};
    width: auto;
    padding: 0;

    ${media.greaterThan(breakpoints.mobile)`
        margin: 0 auto;
        width: auto;
    `}
`;

export const VideoBlockWrapper = styled.div`
    width: auto;
    display: flex;
    flex-wrap: wrap;
    margin: 0 -20px;

    ${media.lessThan(breakpoints.mobile)`
	margin: 0;
        flex-direction: column;
    `}
`;
